import { useState } from 'react';

import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { postActiveTasks } from '../../../../../MyApi/crm/tasks';

import icons from '../../../../../Data/icons';





const TaskCardDetails = ({    id,
    company,
    name,
    branch,
    start_date,
    end_date,
    status,
    active,}) => {
        const { t } = useTranslation();
        const [activeState, setActive] = useState(active);
        const mutationActive = useMutation(
          ["postActive", id],
          (postData) => postActiveTasks(postData, id),
          {
            onSuccess: (data) => {
              toast.success(`${data.message}`);
            },
            onError: (error) => {
              toast.error(`${error.response.data.message}`);
            },
          }
        );
        const titles = {
          id: "#",
          company: t("company"),
          branch: t("branch"),
          start_date: t("start_date"),
          end_date: t("end_date"),
          status: t("status"),
            active: t("active"),
        };
    
        const handelChangeActive = (e) => {
          const isChecked = e.target.checked;
          const newActiveState = isChecked ? 1 : 0;
      
          setActive(newActiveState);
          mutationActive.mutate({
            active: newActiveState,
          });
        };
     

  const IdCard = icons.idCard;
  const Company = icons.company;
  const Branch = icons.branch;
  const Date = icons.date;
  const Status = icons.status;
  const ActiveIcon = icons.active;
  return (
    <div className="col-6">
    <div className="card">
      <div className="post-about card-body">
        <ul className="list-group">
          <li className="list-group-item">
            <div className="icon">
              <IdCard />
            </div>
            <div>
              <h5 className="mb-1">{titles.id}</h5>
              <p>{id} - {name}  </p>
            </div>
          </li>
          <li className="list-group-item">
            <div className="icon">
              <Company />
            </div>
            <div>
              <h5 className="mb-1">{titles.company}</h5>
              <p>{company}</p>
            </div>
          </li>
          <li className="list-group-item">
            <div className="icon">
              <Branch />
            </div>
            <div>
              <h5 className="mb-1">{titles.branch}</h5>
              <p>{branch}</p>
            </div>
          </li>
          <li class="list-group-item">
            <div class="icon">
              <Date />
            </div>
            <div>
              <h5 className="mb-1">{titles.start_date}</h5>
              <p>{start_date}</p>
            </div>
          </li>
          <li class="list-group-item">
            <div class="icon">
              <Date />
            </div>
            <div>
              <h5 className="mb-1">{titles.end_date}</h5>
              <p>{end_date}</p>
            </div>
          </li>
          <li class="list-group-item">
            <div class="icon">
              <Status />
            </div>
            <div>
              <h5 className="mb-1">{titles.status}</h5>
              <p>{status}</p>
            </div>
          </li>
          <li class="list-group-item">
            <div class="icon">
              <ActiveIcon />
            </div>
            <div>
              <h5 className="mb-1">{titles.active}</h5>
              <p><div>
          <label class="switch">
            <input
              type="checkbox"
              onChange={handelChangeActive}
              checked={activeState}
            />
            <span class="slider round"></span>
          </label>
        </div></p>
            </div>
          </li>    
        </ul>
      </div>
    </div>
  </div>
  )
}

export default TaskCardDetails